<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'

const props = defineProps<{
  opened?: boolean
  lazy?: boolean
  standalone?: boolean
}>()

const emit = defineEmits<(e: 'remove') => void>()
</script>

<template>
  <Disclosure
    v-slot="{ open }"
    :default-open="!!opened"
    as="div"
    class="rounded-lg bg-white"
    :class="
      standalone ? 'ring-1 ring-black ring-opacity-5 shadow' : 'shadow-sm'
    "
  >
    <DisclosureButton
      class="flex justify-between items-center w-full cursor-pointer"
      :class="[
        opened || open
          ? `rounded-t-lg ${opened ? 'cursor-auto' : 'hover:bg-gray-50'} ${
              standalone ? '' : 'border-t border-l border-r '
            }`
          : `rounded-lg hover:bg-gray-50 ${standalone ? '' : 'border'}`,
        standalone ? 'px-4 py-3 md:px-6 md:pb-4 md:pt-4' : 'py-3 px-4',
      ]"
      as="div"
    >
      <slot name="button" />
      <div class="flex items-center space-x-1">
        <Button
          v-tooltip.top="{
            value: `This button removes item from list. You need to submit changes using 'SAVE' button`,
            pt: {
              arrow: {
                style: {
                  borderBottomColor: 'var(--primary-color)',
                },
              },
              text: 'bg-primary text-[10px] text-center font-medium',
            },
            showDelay: 1000,
            hideDelay: 300,
          }"
          variant="simple"
          class="text-gray-400 hover:text-red-800 hover:bg-red-100"
          @click.stop="emit('remove')"
        >
          <div class="i-heroicons-outline-trash" />
        </Button>
        <div
          v-if="!opened"
          class="i-heroicons-solid-chevron-down text-md text-gray-500"
          :class="{ 'transform rotate-180': open }"
        />
      </div>
    </DisclosureButton>
    <DisclosurePanel
      :static="!!opened"
      :unmount="!!lazy"
      class="text-gray-500 rounded-b-lg bg-white"
      :class="[
        standalone
          ? 'px-4 py-5 md:px-6 md:pb-6 md:pt-3'
          : 'border-l border-r border-b px-4 pt-2 pb-4',
      ]"
    >
      <slot />
    </DisclosurePanel>
  </Disclosure>
</template>
